import { render, staticRenderFns } from "./03_rollscreen.vue?vue&type=template&id=212442c1&scoped=true&"
import script from "./03_rollscreen.vue?vue&type=script&lang=js&"
export * from "./03_rollscreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "212442c1",
  null
  
)

export default component.exports